// @flow

import { h }              from "preact";
import { PureComponent }  from "shared-components";
import styles             from "./styles.scss";
import classNames         from "classnames";
import Helmet             from "preact-helmet";
import { connect }        from "preact-redux";
         
import { getDefaultMeta, getDefaultLink } from "../../helpers/getMetaData";

import AppHeader      from "../AppHeader";
import SystemMessages from "../SystemMessages";

@connect(
  state => ({
    pathname : state.router.location ? state.router.location.pathname : state.server.pathname,
  })
)
export default class App extends PureComponent {
  render({ children, pathname }: Props, state: any, { t }: Context) {
    return (
      <div class={styles.block}>
        <Helmet
            titleTemplate={`%s | ${t("META.TITLE")}`}
            htmlAttributes={{
              dir  : t("LOCALE.DIR"),
              lang : t("LOCALE.ISO.IETF")
            }}
            meta={getDefaultMeta(t)}
            link={getDefaultLink()}
            script={[
              { src : `https://use.typekit.net/${t("LOCALE.TYPEKIT_ID")}.js` },
              { innerHTML : "try{Typekit.load({ async: true });}catch(e){}" }
            ]}
        />

        <AppHeader />

        <main class={styles.main}>
          {children}
        </main>

        <SystemMessages />
      </div>
    );
  }
}
